import React, { useEffect, useState } from 'react'

const App = ({ field }) => {
  const [activePage, setActivePage] = useState(0)
  const [finalAnswer, setFinalAnswer] = useState(0)
  const [stages, setStages] = useState(0)
  const [result, setResult] = useState({})
  const [currentAnswer, setCurrentAnswer] = useState(-1)

  const quizLength = JSON.parse(field).questions.length - 1

  useEffect(() => {
    fetch('/stages.json')
      .then((response) => response.json())
      .then((data) => {
        setStages(data)
      })
  }, [])

  const handleAnswer = (value, page) => {
    location.href = '#quiz'

    setActivePage(page)

    setCurrentAnswer(-1)

    if (value > finalAnswer) {
      setFinalAnswer(value)

      stages.map((stage) => {
        if (value == stage.id) {
          setResult(stage)
        }
      })
    }
  }

  const resetQuiz = () => {
    location.href = '#quiz'
    setActivePage(0)
    setCurrentAnswer(-1)
    setFinalAnswer(0)
  }

  const padLeadingZeros = (num, size) => {
    var s = num + ''
    while (s.length < size) s = '0' + s
    return s
  }

  return (
    <div className='quiz'>
      {JSON.parse(field).questions.map((data, index) => (
        <div
          key={index}
          className={`quiz__question${activePage === index ? ' active' : ''}`}
        >
          <div role='group'>
            <legend>{data.question}</legend>

            <div className='quiz__counter'>
              <span className='count'>
                {padLeadingZeros(activePage + 1, 2)}&nbsp;/&nbsp;
              </span>
              <span className='length'>
                {padLeadingZeros(quizLength + 1, 2)}
              </span>
            </div>

            <div className='quiz__answers'>
              {data.answers.map((answer, index) => (
                <label key={index}>
                  <input
                    type='radio'
                    name='question'
                    value={answer.id}
                    onClick={() => setCurrentAnswer(answer.id)}
                  />
                  <span>{answer.label}</span>
                </label>
              ))}
            </div>
          </div>
        </div>
      ))}

      <div
        className={`quiz__answer ${activePage > quizLength ? ' active' : ''}`}
      >
        <div className='quiz__answer__content'>
          <span className='quiz__answer__content__preheader'>
            Your perfect stage.
          </span>
          <h4>{result.title}</h4>
          <div className='copy'>
            <div dangerouslySetInnerHTML={{ __html: result.excerpt }} />
          </div>
          <a href={result.url} className='button secondary'>
            Learn More
          </a>
          <button onClick={() => resetQuiz()} className='button secondary'>
            Retake Quiz
          </button>
        </div>
        <div className='quiz__answer__image'>
          <img src={result.image} alt={result.alt} />
        </div>
      </div>

      <div className='quiz__buttons'>
        <button
          className={`secondary ${activePage > quizLength ? 'hide' : ''}`}
          onClick={() => handleAnswer(0, activePage - 1)}
          disabled={activePage === 0}
        >
          Back
        </button>

        <button
          onClick={() => handleAnswer(currentAnswer, activePage + 1)}
          className={`secondary ${activePage < quizLength ? 'show' : 'hide'}`}
          disabled={currentAnswer === -1}
        >
          Next
        </button>

        <button
          onClick={() => handleAnswer(currentAnswer, activePage + 1)}
          className={`secondary ${activePage === quizLength ? 'show' : 'hide'}`}
          disabled={currentAnswer === -1}
        >
          Submit
        </button>
      </div>
    </div>
  )
}

export default App
